// config.js用来存放一些公共的参数 例如我们请求的api地址

export default {
    // bashUrl: "http://test.weibaofeng.cn/admin",
    // domain:"http://test.weibaofeng.cn"
    // bashUrl: "https://api.haofang0375.com/admin",
    bashUrl: "https://api.haofang0375.cn/admin",
    // domain: "https://api.haofang0375.com"
    domain: "https://api.haofang0375.cn"
}